/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const orderStatus = {
  OPEN: 'OPEN',
  FILLED: 'FILLED',
  PARTIAL_FILL: 'PARTIAL_FILL',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
} as const

export type OrderStatus = (typeof orderStatus)[keyof typeof orderStatus]
